import React, { useContext } from "react";
import { AppContext } from "../context/AppContext";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import DisplaySettings from "../utils/globalSetting";
import * as FileSaver from 'file-saver';
import XLSX from  'sheetjs-style';
import { useDeleteBatchMutation } from "../store/apis/api";

export default function Table ( {title, data, page}  ) { 

    const { triggerBatchRefresh } = useContext(AppContext);

    const [deleteBatch, { isLoading }] = useDeleteBatchMutation();
    
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const settings = useContext(DisplaySettings);
    const navigate = useNavigate();
    let keys = [];
    if (data.length > 0) {
        keys = Object.keys(data[0]);
    }

    const handleDownload = async () => {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = { Sheets: {'data': ws}, 'SheetNames': ['data']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        const data_download = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data_download, 'Overview_of_batches.xlsx');
    }

    const handleGotToBatch = (event) => {
        // const id = event.currentTarget.getAttribute("data-rowid");
        const id = event.currentTarget.parentNode.getAttribute("data-rowid");
        let rowData = data[id];
        if (page === 1){
            settings.updateSettings({'type':"showBatchName", 'value':rowData['Name']});
            navigate("/resultsOneBatch");
        }
        if (page === 2){
            settings.updateSettings({'type':"showBatchName", 'value':rowData['']});
            settings.updateSettings({'type':"showModuleName", 'value':rowData['']});

        }
    }

    const handleDeleteCLick = async(event) => {
        const id = event.currentTarget.parentNode.getAttribute("data-rowid");
        let rowData = data[id];
        let batchName = rowData['Name'];

        var answer = window.confirm("Are you sure you want to delete batch " + batchName + "?");
        if (answer) {      
            try {
                const response = await deleteBatch(batchName).unwrap();
                alert("Success: batch " + batchName + " deleted");

                // 🔄 Trigger ResultsHighLevel page to refetch batches
                triggerBatchRefresh();
                // window.location.reload(false);

            } catch (error) {
                console.log(error);
            }  
        }
    }

    return (
        <Container>
            <div className="sub-heading">
                <h3> {title} </h3>
                <h5> Click on a row to go to the analysis for specific batch. </h5>
            </div>
        <STable>
            <STHead>
                <STHeadTR>
                    {keys.map((item, index) => (  
                        <STH key={index} style={{fontWeight: "bold"}}>{item}</STH>
                    ))}
                    <STH/>
                </STHeadTR>
            </STHead>
            <STBody>
                {data.map((obj, index) => (
                    <STBodyTR key={index} data-rowid={index} > 
                        {keys.map((item, i) => {
                            const value = obj[item];
                            return <STD onClick={handleGotToBatch} style={i === 0 ? 
                            { fontWeight: "bold"} : { fontWeight: "normal"}}
                            key={i}>{value}</STD>;
                        })}                 
                        <STD onClick={handleDeleteCLick} style={{color: "#A30000", fontWeight: "bold"}}> Delete  </STD>
                    </STBodyTR>
                ))}
            </STBody>
        </STable>
        <BTN>
            <button onClick={handleDownload}> Download </button>
        </BTN>
        </Container>
    );
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .sub-heading {
        padding: 0.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
    }
`;

export const STable = styled.table`
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    overflow: hidden;
    align-items: center;
    justify-content: center;    
    box-shadow: rgba(0, 0, 0, 0.75) 0px 3px 10px;
    border-radius: 5px;
`;
// border: 1px solid black;

export const STHead = styled.thead`        
    z-index: 100;
`;

export const STHeadTR = styled.tr`
    background: #efefef;
`;

export const STH = styled.th`
    font-weight: normal;
    padding: 1rem;
    color: black;
    text-transform: capitalize;    
    font-size: 14px;     
    fontWeight: bold;   
`;
// border: 1px solid black;

export const STBody = styled.tbody``;

export const STBodyTR = styled.tr`
    background: white;
    :hover {
        cursor: pointer;
        background-color: #CAD4D1;
    }
`;

export const STD = styled.td`
    padding: 1rem;    
    font-size: 14px;
`;

export const BTN = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;    
    padding: 1rem;
    button {
        padding: 0.5rem 1rem;
        background-color: #E55B41;
        border: none;
        cursor: pointer;
        color: white;
        border-radius: 0.2rem;
        font-weight: bolder;
        font-size: 1.05rem;
    }
`;

// border: 1px solid black;

// :not(:last-of-type) {
//     border-right: 1px solid black;
// }
// :first-of-type {
//     width: 1%;
//     white-space: nowrap;
// }